import angular from "angular";
import module from "./module";

import { buildUrl } from "#/utils/api";

module.factory("AuthorizationInterceptorService", AuthorizationInterceptorService);
/* @ngInject */
function AuthorizationInterceptorService($rootScope, $q, $injector, PrincipalService) {
  var interceptor = {};

  interceptor.request = function(config) {
    config.headers = config.headers || {};
    var token = PrincipalService.getIdentity().token;
    if (angular.isUndefined(config.headers.Authorization) && config.method !== "OPTIONS" && token) {
      config.headers.Authorization = "Token" + token;
    }
    return config || $q.when(config);
  };

  interceptor.requestError = function(rejection) {
    return $q.reject(rejection);
  };

  interceptor.response = function(response) {
    if (response.status === 401) {
      $rootScope.$broadcast("user-logout");
    }
    return response || $q.when(response);
  };

  interceptor.responseError = function(rejection) {
    var url = (rejection.config && rejection.config.url) || "";
    
    var skipNotification = 
      url.match(buildUrl("status")) ||
      url.match("importablePatients") ||
      url.match(buildUrl("login")) ||
      (url.match("clinics/.*/schedule/.*") && rejection.status === 404) ||
      rejection.config.skipErrorNotification === true;
    
    if(skipNotification) {
      return $q.reject(rejection);
    }
      
    switch (rejection.status) {
      case 0:
        if (rejection.config.url.indexOf("notification") !== -1) {
          break;
        }
        $rootScope.error = rejection.statusText = "No connection to API or Connection is refused";
        $rootScope.$broadcast("user-logout");
        return $q.reject(rejection);

      case 401:
        $rootScope.$broadcast("user-logout");
        return $q.reject(rejection);

      case 403:
        $rootScope.$broadcast("user-logout");
        return $q.reject(rejection);

      case 503:
        if (rejection.config.url.match(buildUrl(""))) {
            $rootScope.error = "No connection to API or Connection is refused";
            $rootScope.$broadcast("user-logout");
          } else {
          if (elem.length !== 0) {
            if (!rejection.config.url.match(buildUrl("address", "reference")))
              $injector
                .get("NotificationsService")
                .apiError(elem, "", rejection.statusText, false, false);
          } else {
            alert(rejection.statusText);
          }
        }
        break;
      default:
        _showErrorNotification(rejection, $injector);
        break;
    }
    return $q.reject(rejection);
  };

  function _showErrorNotification(rejection, $injector) {
    var url = (rejection.config && rejection.config.url) || "";
    var status = rejection.status;
    var statusText = rejection.statusText || "";
    var data = rejection.data || {};
    
    var elem = _findNotificationTarget();
    
    if (elem.length === 0) {
      alert(_getErrorMessage(rejection));
      return;
    }

    var NotificationsService = $injector.get("NotificationsService");
    var title = _getErrorTitle(status);
    var message = _getErrorMessage(rejection);
    
    NotificationsService.apiError(elem, title, message, null, false, 60000);
  }

  function _findNotificationTarget() {
    var selectors = [
      "fieldset",
      "table", 
      ".subnav-container + *",
      "#mainview",
      "body"
    ];
    
    for (var i = 0; i < selectors.length; i++) {
      var elem = angular.$(document).find(selectors[i]);
      if (elem.length > 0) {
        return elem;
      }
    }
    
    return angular.$();
  }

  function _getErrorTitle(status) {
    switch (status) {
      case 400:
        return "Bad Request";
      case 404:
        return "Not Found";
      case 500:
        return "Server Error";
      case 503:
        return "Service Unavailable";
      default:
        return "Error " + status;
    }
  }

  function _getErrorMessage(rejection) {
    var status = rejection.status;
    var statusText = rejection.statusText || "";
    var data = rejection.data || {};
    
    var message = "";
    
    if (angular.isString(data)) {
      message = data;
    } else if (data.detail) {
      message = data.detail;
    } else if (data.message) {
      message = data.message;
    } else if (data.error) {
      message = angular.isString(data.error) ? data.error : data.error.message;
    } else if (data.title) {
      message = data.title;
    } else if (statusText) {
      message = statusText;
    }
 
    
    if (!message) {
      switch (status) {
        case 400:
          message = "The request was invalid. Please check your input and try again.";
          break;
        case 404:
          message = "The requested resource could not be found.";
          break;
        case 500:
          message = "An internal server error occurred. Please try again later.";
          break;
        case 503:
          message = "The service is temporarily unavailable. Please try again later.";
          break;
        default:
          message = "An unexpected error occurred. Please try again.";
      }
    }
    
    return message;
  }

  return interceptor;
}
